import React from 'react';
import UsedVehicles from '../components/UsedVehicles';
import { Search, ShieldCheck, Banknote, PenTool } from 'lucide-react';

const VenteAuto = () => {
  return (
    <div className="vente-auto-page">
      {/* Section Hero Impact */}
      <section className="sales-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-badge">Occasions de Qualité</span>
          <h1 className="hero-title">Trouvez votre prochain<br/><span>véhicule de confiance.</span></h1>
          <p className="hero-subtitle">
            Chaque voiture est une opportunité. Chez Christophe Dépanne, nous sélectionnons, 
            révisons et garantissons chaque modèle de notre catalogue.
          </p>
        </div>
      </section>
      
      {/* Catalogue complet (UsedVehicles) */}
      <UsedVehicles />
      
      {/* Section nos services premium */}
      <section className="sales-benefits">
        <div className="container">
          <div className="section-intro">
            <h2>L'accompagnement Christophe Dépanne</h2>
            <p>Plus qu'une simple vente, nous vous offrons une expérience sereine et transparente.</p>
          </div>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon"><Search size={32} /></div>
              <h3>Expertise Totale</h3>
              <p>Contrôle technique approfondi et préparation esthétique de chaque véhicule avant exposition.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon"><ShieldCheck size={32} /></div>
              <h3>Garantie Incluse</h3>
              <p>Partez l'esprit tranquille avec une garantie mécanique sur tous nos modèles d'occasion.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon"><Banknote size={32} /></div>
              <h3>Financement</h3>
              <p>Nous vous accompagnons dans la recherche des meilleures solutions de financement adaptées.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon"><PenTool size={32} /></div>
              <h3>Service Après-Vente</h3>
              <p>Entretien et suivi de votre futur véhicule directement par nos soins, avec une remise privilégiée.</p>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .vente-auto-page {
          background-color: #f8fafc;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        /* Hero Section */
        .sales-hero {
          position: relative;
          height: 65vh;
          min-height: 500px;
          background: url('https://images.unsplash.com/photo-1486006920555-c77dcf18193c?auto=format&fit=crop&q=80&w=1600') center/cover no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(26, 36, 47, 0.9), rgba(26, 36, 47, 0.5));
          z-index: 1;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 850px;
          padding: 0 20px;
        }

        .hero-badge {
          background: #3b82f6;
          color: white;
          padding: 6px 16px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 25px;
          display: inline-block;
        }

        .hero-title {
          font-size: 3.8rem;
          font-weight: 900;
          margin-bottom: 25px;
          line-height: 1.1;
        }

        .hero-title span { color: #3b82f6; }

        .hero-subtitle {
          font-size: 1.3rem;
          opacity: 0.9;
          max-width: 650px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* Benefits Section */
        .sales-benefits {
          padding: 100px 0;
          background: white;
        }

        .section-intro {
          text-align: center;
          margin-bottom: 70px;
        }

        .section-intro h2 {
          font-size: 2.5rem;
          color: #1a242f;
          font-weight: 800;
          margin-bottom: 15px;
        }

        .section-intro p {
          color: #64748b;
          font-size: 1.15rem;
        }

        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 40px;
        }

        .benefit-card {
          padding: 40px 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #f1f5f9;
          transition: all 0.3s ease;
          text-align: center;
        }

        .benefit-card:hover {
          transform: translateY(-10px);
          background: white;
          box-shadow: 0 20px 40px rgba(0,0,0,0.05);
          border-color: #3b82f6;
        }

        .benefit-icon {
          width: 70px;
          height: 70px;
          background: white;
          color: #3b82f6;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 20px;
          margin: 0 auto 25px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          transition: all 0.3s;
        }

        .benefit-card:hover .benefit-icon {
          background: #3b82f6;
          color: white;
        }

        .benefit-card h3 {
          font-size: 1.4rem;
          color: #1a242f;
          margin-bottom: 15px;
          font-weight: 700;
        }

        .benefit-card p {
          color: #64748b;
          line-height: 1.6;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .hero-title { font-size: 2.5rem; }
          .hero-subtitle { font-size: 1.1rem; }
          .sales-benefits { padding: 60px 0; }
        }
      `}</style>
    </div>
  );
};

export default VenteAuto;
